import { useNavigate } from 'react-router-dom';

import {
  openErrorNotification,
  openSuccessNotification,
  isErrorWithMessage,
} from 'shared/lib';

import {
  useAddMobileAppMutation,
  MobileAppFormData,
  MobileAppFormProps,
  MobileAppForm,
} from 'entities/mobile-app';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';
import { MOBILE_APP_ROUTES } from 'shared/consts/routes/mobile-app';

const initialValues: MobileAppFormData = {
  id: '',
  name: '',
  description: '',
};

export function AddMobileApp() {
  const [trigger, { isLoading }] = useAddMobileAppMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: MobileAppFormData) => {
    const { id, ...rest } = values;

    try {
      const res = await trigger(rest).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(`${MOBILE_APP_ROUTES.MOBILE_APPS}/${res.mobileApp.id}`);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <MobileAppForm
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
      title="Добавление нового мобильного приложения"
    />
  );
}
